import TvPressable from './tv_pressable';

export default TvPressable;
